var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6497 8.66683L14.4908 6.87222C14.6886 6.67937 14.5794 6.34338 14.306 6.30365L10.3286 5.7257C10.2201 5.70993 10.1262 5.64174 10.0776 5.54336L8.29891 1.93923C8.17663 1.69148 7.82335 1.69148 7.70108 1.93923L5.92234 5.54336C5.87378 5.64174 5.77993 5.70993 5.67136 5.7257L1.69397 6.30365C1.42056 6.34338 1.31139 6.67937 1.50923 6.87222L4.3873 9.67764C4.46586 9.75422 4.50171 9.86455 4.48316 9.97269L3.80374 13.934C3.75704 14.2063 4.04285 14.414 4.28739 14.2854L7.84488 12.4151C7.94199 12.3641 8.058 12.3641 8.15511 12.4151L9.33333 13.0345M12 13.3336H13.3333M13.3333 13.3336H14.6667M13.3333 13.3336V12.0002M13.3333 13.3336L13.3333 14.6669",
    stroke: "#29B77E",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.bf77cf82855bee13f856f15b3e037ba4.svg";
export { ForwardRef as ReactComponent };